import { For, Index, type JSX } from "solid-js";

import { Icon } from "~/icon";

import { ProcedureArt } from "../art/procedure_art";
import styles from "../deck.module.css";
import type { CareSlide as CareSlideData } from "../types";

/** How to look after the new work: each treatment's tips from Twelve's library, under its drawing. */
export function CareSlide(props: { slide: CareSlideData }): JSX.Element {
  return (
    <>
      <h2 class={styles["s-h"]}>{props.slide.headline}</h2>
      <ul class={styles["care"]} style={{ "--n": Math.max(props.slide.families.length, 1) }}>
        <Index each={props.slide.families}>
          {(family) => (
            <li class={styles["care-c"]}>
              <div class={styles["care-art"]}>
                <ProcedureArt art={family().art} title={family().title} />
              </div>
              <h3 class={styles["care-t"]}>{family().title}</h3>
              <ul class={styles["care-tips"]}>
                <For each={family().tips}>
                  {(tip) => (
                    <li>
                      <Icon name="check" size="none" aria-hidden="true" />
                      <span>{tip}</span>
                    </li>
                  )}
                </For>
              </ul>
            </li>
          )}
        </Index>
      </ul>
    </>
  );
}
